<template>
  <v-simple-table class="bordered-table">
    <template #default>
      <table-head>
        <template #thead>
          <th class="text-center header pa-1">
            <div class="text-black">
              {{ columnTitle }}
            </div>
          </th>
          <th class="text-center header pa-1">
            <div class="text-black">Clientes</div>
          </th>
        </template>
      </table-head>
      <tbody>
        <table-body-loader v-if="loading" />
        <template v-else>
          <tr class="bg-gray">
            <td>Total</td>
            <td>{{ items.allCustomers }}</td>
            <td v-for="(item, index) in items.totals[metric]" :key="index">
              {{ item }} <br />
              {{ formatFloat((item / items.allCustomers) * 100, 2) }}%
            </td>
          </tr>
          <template v-for="(item, index) in items.data">
            <tr :key="`customers-${index}`">
              <td class="pre-line font-weight-bold">
                <a class="text-black" @click="optionSelected(item)">
                  {{ item.label }}
                </a>
              </td>
              <td>
                {{ item.currentCustomers }} <br />
                {{ item.percent }}%
              </td>
              <td v-for="(stats, subindex) in item.stats" :key="subindex">
                {{ stats[metric].value }} <br />
                {{ stats[metric].percentage }}%
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import TableBodyLoader from '@/components/tables/TableBodyLoader.vue';
  import TableHead from './TableHead.vue';

  import numbersFormats from '@/mixins/numbersFormats';
  import Helpers from '@/mixins/helpers';

  export default {
    name: 'CustomersTable',
    components: { TableHead, TableBodyLoader },
    mixins: [numbersFormats, Helpers],
    props: {
      items: {
        default: () => [{}],
      },
      loading: {
        default: true,
        type: Boolean,
      },
      columnTitle: {
        type: String,
        default: 'Zona',
      },
      metric: {
        type: String,
        default: '',
      },
    },
    methods: {
      optionSelected(value) {
        this.$emit('optionSelected', value);
      },
    },
  };
</script>
<style scoped>
  .first-row td {
    background: #e0e0e0 0% 0% no-repeat padding-box;
    border: 1px solid #a6a3a3 !important;
  }

  .bordered-table td {
    border: 1px solid #dde1e6;
  }
</style>
